import { Directive, HostBinding, HostListener, inject, Input } from '@angular/core';

import { PopoverService } from '@services/popover.service';
@Directive({
  selector: '[app-popover]',
})
export class PopoverDirective {
  private popoverService = inject(PopoverService);
  @HostBinding('attr.data-popover') @Input('app-popover') popover?: string;
  @Input('popover-size') popoverSize?: number;

  @HostListener('click', ['$event.target']) onClick(): void {
    if (this.popover) this.popoverService.toggle(this.popover, this.popoverSize);
  }
}
